import React, { useContext, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import ProductThumbnail from '../ProductThumbnail';
import './style.scss';

import { ProductsContext } from 'context/ProductsContext';

export default function ProductList() {
  const { products, setSelectedProduct, setPage, itemKeyword } = useContext(ProductsContext);
  // const [filtProds, setFiltProds] = useState([...products]);

  // useEffect(()=>{
  //   const copy = [...products];
  //   const filtCopy = copy.filter(product => product.title === itemKeyword);
  //   setFiltProds(filtCopy);
  // },[itemKeyword])

  useEffect(() => {
    setSelectedProduct({});
  }, [setSelectedProduct]);


  return (
    <div>
      <InfiniteScroll
        dataLength={products.length}
        next={() => setPage((prevState) => prevState + 1)}
        hasMore={true}
        className="productsLayout"
      >
        {
          itemKeyword === '' ? products.map((product) => (
            <ProductThumbnail key={product.id} product={product} />
          )) : products.filter(product => product.item === itemKeyword).map((product) => (
            <ProductThumbnail key={product.id} product={product} />
          ))
        }

      </InfiniteScroll>
    </div>
  );
}
